<template>
    <div>
        <EditSupplier />
    </div>
</template>

<script>
import EditSupplier from '@/components/supplier/EditSupplier.vue';
export default {
    components: {
        EditSupplier
    },
    name: 'SupplierEdit'
}
</script>